import { useContext } from "react";
import { DeSoIdentityContext } from "react-deso-protocol";
import { Dropdown, InputGroup, Spinner } from "react-bootstrap";
import { configure, identity } from "deso-protocol";
import W3lyComponent from "./w3ly";

export const systemKey = process.env.REACT_APP_SYSTEM_KEY;
export const appName = process.env.REACT_APP_APPNAME;

const localPreferences = localStorage.getItem('preferences');
const desoActivePublicKey = localStorage.getItem('desoActivePublicKey');
let nodeURI = 'https://node.deso.org';
if (localPreferences) {
  const preferences = JSON.parse(localPreferences);
  if (desoActivePublicKey && preferences[desoActivePublicKey]) {
    nodeURI = preferences[desoActivePublicKey].nodeURI;
  } else {
    // Get the first available nodeURI from preferences
    const firstKey = Object.keys(preferences)[0];
    if (firstKey && preferences[firstKey].nodeURI) {
      nodeURI = preferences[firstKey].nodeURI;
    }
  }
}

export const AppLoader = () => {
  const { isLoading } = useContext(DeSoIdentityContext);
  return (
      <>
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <W3lyComponent /> 
        )}
      </>
  );
};



export const LoadingScreen = () => (
  <div key={`loadingScreen`} className="d-flex flex-column vh-100 justify-content-center">
    <div className="container align-items-center text-center">
      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-row flex-nowrap align-items-center justify-content-center">
            <div>
              <img src="assets/BeyondSocial_100px.png" className="me-3"/>
            </div>
            <div className="lh-sm fw-light">
              <div className="fs-1 m-0 p-0">
                <span className="fw-bold">Beyond</span><span className="fw-light fs-i text-muted"><em>Social</em></span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 text-center mt-3">
          <Spinner animation="border" />
        </div>
      </div>
    </div>
  </div>
);

export const configureLogin = () => {
    configure({
        spendingLimitOptions: {
            "GlobalDESOLimit": 1000000000,
            "TransactionCountLimitMap": {
                "UPDATE_PROFILE": 1000000000,
                "CREATE_NFT": 1000000000,
                "UPDATE_NFT": 1000000000,
                "SUBMIT_POST": 1000000000,
                "NEW_MESSAGE": 1000000000,
                "BASIC_TRANSFER": 1000000000,
                "FOLLOW": 1000000000,
                "LIKE": 1000000000,
                "CREATOR_COIN": 1000000000,
                "CREATOR_COIN_TRANSFER": 1000000000,
                "ACCEPT_NFT_BID": 1000000000,
                "BURN_NFT": 1000000000,
                "CREATE_USER_ASSOCIATION": 1000000000,
                "CREATE_POST_ASSOCIATION": 1000000000,
                "ACCESS_GROUP": 1000000000,
                "ACCESS_GROUP_MEMBERS": 1000000000,
                "AUTHORIZE_DERIVED_KEY": 1
            },
            "CreatorCoinOperationLimitMap": {
                "": {
                    "any": 1000000000
                }
            },
            "AssociationLimitMap": [
                {
                    "AssociationClass": "Post",
                    "AssociationType": "",
                    "AppScopeType": "Any",
                    "AppPublicKeyBase58Check": "",
                    "AssociationOperation": "Any",
                    "OpCount": 1000000000
                },
                {
                    "AssociationClass": "User",
                    "AssociationType": "",
                    "AppPublicKeyBase58Check": "",
                    "AppScopeType": "Any",
                    "AssociationOperation": "Any",
                    "OpCount": 1000000000
                }
            ],
            "AccessGroupLimitMap": [
                {
                    "AccessGroupOwnerPublicKeyBase58Check": "",
                    "ScopeType": "Any",
                    "AccessGroupKeyName": "",
                    "OperationType": "Any",
                    "OpCount": 1000000000
                }
            ],
            "AccessGroupMemberLimitMap": [
                {
                    "AccessGroupOwnerPublicKeyBase58Check": "",
                    "ScopeType": "Any",
                    "AccessGroupKeyName": "",
                    "OperationType": "Any",
                    "OpCount": 1000000000
                }
            ],
            "NFTOperationLimitMap": {
                "": {
                    "0": {
                        "any": 1000000000
                    }
                }
            }
        },
        appName: appName,
        showSkip: true,
        nodeURI: nodeURI,
    });
};

export const handleLogin = () => {
    configureLogin(); 
    identity.login();
};

export const UserDropdown = ({ loginText = "Login" }) => {
    const { currentUser, alternateUsers, isLoading } = useContext(DeSoIdentityContext);

    if (isLoading) {
        return (
            <div className="spinner-border text-muted spinner-border-sm" role="status" aria-hidden="true"></div>
        );
    }

    if (!currentUser) {
        return (
            <button className="btn btn-sm mx-auto" onClick={handleLogin}>
                {loginText}
            </button>
        );
    }

    return (

        <Dropdown className="w-100">
            <Dropdown.Toggle variant="" className="w-100 d-flex align-items-center ps-0 py-0 navbarbtn">
                <img
                    className="deso_avatar"
                    title={currentUser?.ProfileEntryResponse?.Username || currentUser?.PublicKeyBase58Check}
                    src={`https://node.deso.org/api/v0/get-single-profile-picture/${currentUser.PublicKeyBase58Check}`}
                    alt="User Avatar"
                />
                <div className="ms-2 text-start overflow-hidden">
                    <span className="text-truncate d-block">
                        {currentUser?.ProfileEntryResponse?.Username || currentUser?.PublicKeyBase58Check}
                    </span>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu align="center" className="py-0">
                {alternateUsers?.length > 0 && alternateUsers.map((user) => (
                    <Dropdown.Item key={user.PublicKeyBase58Check} className="px-2" onClick={() => identity.setActiveUser(user.PublicKeyBase58Check)}>
                        <img className="deso_avatar mx-2" src={`https://node.deso.org/api/v0/get-single-profile-picture/${user.PublicKeyBase58Check}`} />
                        {user?.ProfileEntryResponse?.Username || user?.PublicKeyBase58Check}
                    </Dropdown.Item>
                ))}
                <Dropdown.Item className="px-2" onClick={async () => {
                    await identity.logout();
                    if (alternateUsers.length > 0) {
                        identity.setActiveUser(alternateUsers[0].PublicKeyBase58Check);
                    }
                }}>
                    <i className="bi bi-power text-danger mx-2"></i>
                    Logout as {currentUser.ProfileEntryResponse.Username}
                </Dropdown.Item>
                <Dropdown.Item className="p-1 px-2" onClick={handleLogin}>
                    <i className="bi bi-person-fill text-success mx-2"></i>
                    Add account
                </Dropdown.Item>
            </Dropdown.Menu>
    </Dropdown>
    

    );
};
